import { reduxDispatch } from "../diProviders";
import { appSettings } from "./appSettingsManager";
import { setAppSettings } from "./appSlice";
const initializeAppSettings = ({ appId }) => {
    const syncSettingsToStore = () => {
        const settings = appSettings.getSettings();
        if (settings && reduxDispatch) {
            reduxDispatch(setAppSettings(settings));
        }
    };
    appSettings.subscribe(syncSettingsToStore);
    void appSettings.init({ appId });
};
export default initializeAppSettings;
